import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { RadioButton, DropDown, Input, ModalMsgCtrl, Tooltip2 } from '../components';
import { catOfferType, lstSearchFilter } from '../data/MochaData'
import http from '../../../services/http';
import { endPoints } from '../../../utils/constanst';
import { GetDataByListPolicy, formatMoney } from '../data/Help'
import { useModal } from '../hook/useModal';
import { IconCopy } from '../img'
import { EncryptData } from '../../../utils/helpMain'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Step2 = () => {
    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);
    const [lstPolicy, setLstPolicy] = useState([]);
    const modalLoading = useModal({ isloading: true } as IModalProps);

    useEffect(() => {
        setAutoCR({
            ...AutoCR,
            isEdit: false,
            catCoverage: [],
            lstCoverageExt: [],
            catBranch: [],
            otherVehicleBrand: '',
            vehicleModel: '',
            catModel: [],
            catDeductible: [],
            catQuotas: [],
            vehicleBrand: '',
            catDiscount: [],
            maxDiscount: 0,
            idDiscount: 0,
            plan: '',
            typeDocumentInsured: '',
            identificationInsured: '',
            firstName: '',
            lastName: '',
            mail: '',
            phone: '',
            civilStatus: '',
            deductible: '',
            vehicleDevice: '',
            vehicleUse: '',
            vehicleStatus: '',
            vehicleValue: ''
        })
    }, [])

    const onChange = (property: string, value: string) => setAutoCR({ ...AutoCR, [property]: value });

    const GetListPolicy = () => {
        setLstPolicy([])
        if (AutoCR.searchFilter === '') return;
        if (AutoCR.filterData === '') return;
        modalLoading.show('Buscando...');
        const data = GetDataByListPolicy(AutoCR);
        http(endPoints.listPolicy)
            .post(data)
            .then(x => {
                setLstPolicy(x)
            }).finally(() => {
                modalLoading.hide()
            })
    }

    const getTextDetail = (data: IPolicyInfoCR) => (`N° Oferta: ${data.id} \n Marca: ${data.brand} \n Modelo: ${data.model} \n Año: ${data.year} \n Prima: ${formatMoney(data.currency, data.prima)} \n Estado: ${data.statusDesc}`);

    const GetPolicy = (id: string) => setAutoCR({ ...AutoCR, isEdit: true, idPoliza: id, loadedPolicy: true });

    const OnClick = (id: string) => {

        let path = window.location.pathname;
        if (path.endsWith('/'))
            path = path.substring(0, path.length - 1)
        navigator.clipboard.writeText(`${window.location.origin}${path}/emision/${EncryptData(id)}`);
        toast("URL copiado");

    }

    return (
        <>
            <RadioButton
                label='Esta es una nueva oferta o quieres recuperar una oferta?'
                catalog={catOfferType}
                value={AutoCR.offerType}
                field='offerType'
                onChangeStr={onChange}
                onChange={() => { }}
            />

            {AutoCR.offerType === '2' && <>

                <DropDown
                    label='Seleccionar filtro de búsqueda'
                    field='searchFilter'
                    valueSelect={AutoCR.searchFilter}
                    dataProvider={lstSearchFilter}
                    onChangeSelect={onChange}
                />

                <Input
                    label='Ingrese filtro de búsqueda'
                    value={AutoCR.filterData}
                    onChange={changeHandler}
                    field='filterData'
                    id='filterData'
                    useToolTip={true}
                    titleToolTip='Recuerda'
                    textToolTip='Debes envíar el link de la oferta al cliente'
                    useIconSearch={true}
                    onClickIconSeach={() => GetListPolicy()}

                />
                {lstPolicy.length > 0 && <>
                    <table className='table-auto-cr mt-20'>

                        <tr>
                            <th style={{ textAlign: 'left', paddingLeft: '5px' }}>Nombre</th>
                            <th colSpan={2}>Prima</th>

                        </tr>
                        {lstPolicy.map((x: IPolicyInfoCR) => {
                            return (
                                <tr>
                                    {x.status === 0 && <>
                                        <td onDoubleClick={() => { GetPolicy(x.id.toString()) }}>{x.name}</td>
                                        <td style={{ justifyContent: "end", display: "flex" }} >{formatMoney(x.currency, x.prima)}</td>
                                    </>
                                    }
                                    {x.status === 1 && <>
                                        <td style={{color: '#d43c37'}}>{x.name}</td>
                                        <td style={{ justifyContent: "end", display: "flex", color: '#d43c37' }} >{formatMoney(x.currency, x.prima)}</td>
                                    </>
                                    }
                                    <td>
                                        <div style={{ justifyContent: "end", display: "flex" }} >
                                            <Tooltip2 id={x.id.toString()} key={x.id} text={getTextDetail(x)} title={`Detalle de la ${x.statusDesc}`} />
                                            <IconCopy click={() => OnClick(x.id.toString())} />
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </table>
                </>}

            </>}
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
                progressStyle={{ background: '#008866' }}
                bodyStyle={{
                    color: '#4D4D4D',
                    textAlign: 'center'
                }}
                limit={1}
            />
        </>

    )
}

export { Step2 }